module.exports = __webpack_public_path__ + "static/media/platform_banner.ab6ad51c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/platform_banner.png
// module id = 1902
// module chunks = 0